import React from 'react';
import { Paper, Grid } from '@material-ui/core';


function EmptyResult({className, elevation, message}){
  return(
    // Show Empty courses
    
    <Paper elevation={typeof elevation == "number" ? elevation : 3} className={className}>                
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        style={{height: "5em"}}
      > 
        <div>{message || "There is no data to show"}</div>
      </Grid>                
    </Paper>        
  );
}

export default EmptyResult;